import type { UseWidget } from '@swf/core/hooks/useWidget';
import { useWidget } from '@swf/core/hooks/useWidget';
import type { WidgetModelConfig } from '@swf/core/store';

import type { SportsNextRacesWidgetConfig } from '../config';

import { defaultState } from './defaultState';
import { effects } from './effects';
import { reducers } from './reducers';
import { selectors } from './selectors';

export interface SportsNextRacesWidgetModel
  extends WidgetModelConfig<SportsNextRacesWidgetConfig, typeof defaultState> {
  reducers: typeof reducers;
  effects: typeof effects;
  selectors: typeof selectors;
}

export const sportsNextRacesWidgetModel: SportsNextRacesWidgetModel = {
  state: defaultState,
  reducers,
  effects,
  selectors
};

export const useSportsNextRacesWidget: UseWidget<
  SportsNextRacesWidgetConfig,
  SportsNextRacesWidgetModel
> = useWidget;
